@if (IsExclusive()) {
  <img class="exclusive-badge" [src]="staticImages.miniLogoWhite" alt="exclusive" width="32" />
} @else {
  <div class="sheyda-badge">
    <div class="main-badge {{ Size() }}">
      <span>{{ Text() }}</span>
    </div>
  </div>
}
